const {
	fillWithDomElements,
	twoCiphers,
	awaitNextFrame,
	trackGtm4,
} = require('util/functions.js');

const CLASS_ACTIVE = 'active';

const CLASS_SEARCH = 'ir-search--input-search';
const CLASS_FROM = 'ir-search--input-from';
const CLASS_CALENDAR_FROM = 'ir-search--calendar-from';
const CLASS_TO = 'ir-search--input-to';
const CLASS_CALENDAR_TO = 'ir-search--calendar-to';
const CLASS_CLEAR_ALL = 'ir-search--clear-all';
const CLASS_SUBMIT = 'ir-search--submit';

const elementClasses = {
	search: CLASS_SEARCH,
	fromField: CLASS_FROM,
	calendarFrom: CLASS_CALENDAR_FROM,
	toField: CLASS_TO,
	calendarTo: CLASS_CALENDAR_TO,
	clearAll: CLASS_CLEAR_ALL,
	submit: CLASS_SUBMIT,
};

module.exports = {
	init() {
		fillWithDomElements(this, elementClasses);
		this.template = this.root.dataset.template;
		this.initCalendars();
		this.initEvents();
	},
	initEvents() {
		this.clearAll.addEventListener('click', this.clearAllFields.bind(this));
		const onUpdate = this.onUpdate.bind(this);
		[this.search, this.fromField, this.toField].forEach(element => {
			element.addEventListener('keyup', onUpdate);
		});
		this.submit.addEventListener('click', this.gtmTracking.bind(this));
	},
	gtmTracking() {
		trackGtm4({
			event: 'GA4_event_c_search',
			search_term: this.search.value.length > 0 ? this.search.value : 'none',
			search_location: 'page',
			search_filter: `${this.fromField.value || this.root.dataset.fromLabel}|${
				this.toField.value || this.root.dataset.toLabel
			}`,
			widget_name: 'V3-IR-search',
		});
	},
	async onUpdate() {
		// necessary or else the value of the elements won't be updated
		// and isBlank check wont be accurate
		await awaitNextFrame();

		const fields = [this.search, this.fromField, this.toField];
		const isBlank = !fields.some(el => el.value);
		const hasChanged = fields.some(
			el => el.value !== (el.__initialValue || ''),
		);
		this.submit.classList.toggle(CLASS_ACTIVE, hasChanged && !isBlank);
	},
	async initCalendars() {
		const { default: Pikaday } = await import(
			/* webpackChunkName: "pikaday" */ 'pikaday'
		);
		this.fromPicker = new Pikaday(
			this.getCalendarOptions(this.fromField, this.calendarFrom),
		);
		this.toPicker = new Pikaday(
			this.getCalendarOptions(this.toField, this.calendarTo),
		);
		this.retainParameters();
	},
	getCalendarOptions(field, container) {
		let { months, weekdays, previousMonth, nextMonth } = this.root.dataset;
		[months, weekdays] = [months, weekdays].map(list => list.split(','));
		return {
			field: field,
			container: container,
			disableWeekends: true,
			minDate: this.template === 'upcoming' ? new Date() : undefined,
			maxDate: this.template === 'past' ? new Date() : undefined,
			toString(date) {
				return [date.getMonth() + 1, date.getDate(), date.getFullYear()]
					.map(number => twoCiphers(number))
					.join('/');
			},
			i18n: {
				previousMonth,
				nextMonth,
				months,
				weekdays,
				weekdaysShort: weekdays,
			},
			onOpen: () => {
				// Fixes Chrome issue
				setTimeout(() => {
					container.classList.add(CLASS_ACTIVE);
				}, 100);
			},
			onSelect: () => {
				this.defineFromAndToRules();
				this.onUpdate();
			},
			onClose: () => {
				// Fixes Chrome issue
				setTimeout(() => {
					container.classList.remove(CLASS_ACTIVE);
				}, 100);
			},
		};
	},
	defineFromAndToRules() {
		this.toPicker.setMinDate(this.fromPicker.getDate());
		this.fromPicker.setMaxDate(this.toPicker.getDate());
	},
	// to clear/reset every data that pickers contain,
	// pikaday's clear() method couldn't be use in this case
	clearAllFields() {
		this.submit.classList.toggle(CLASS_ACTIVE, true);
		this.fromPicker.setDate(null);
		this.toPicker.setDate(null);
	},
	retainParameters() {
		const queryString = decodeURIComponent(window.location.search).split(
			'?',
		)[1];

		if (queryString) {
			const params = queryString.split('&');
			let paramObj = {};
			params.forEach(param => {
				let [key, val] = param.split('=');
				// for search's wrong retain
				val = val.split('+').join(' ');
				paramObj[key] = val;
			});
			const assignParam = (el, source, key, isField) => {
				const value = paramObj[key];
				if (typeof value !== 'undefined')
					isField ? (source.value = value) : source.setDate(value);

				el.__initialValue = value || '';
			};
			assignParam(this.search, this.search, 'q', true);
			assignParam(this.fromField, this.fromPicker, 'from');
			assignParam(this.toField, this.toPicker, 'to');
		}
		this.onUpdate();
	},
};
